export class ModalConstants {
    public static transactionUpdateModalId = 'transactionUpdateModal';
    public static bankTransferReceiveModalId = 'bankTransferReceiveModal';
    public static bankTransferSendCommsModalId = 'bankTransferSendCommsModal';
}
